import { Skeleton } from "@material-ui/lab"
import React from "react"

const WhatsappModalSkeleton = () => {
  return (
    <>
      <Skeleton animation="wave" variant="rect" height={60} width={"100%"} style={{ borderRadius: 12 }} />
      <div style={{ flex: 1, display: "flex", flexDirection: "inherit", alignItems: "center", gap: 20, padding: 20 }}>
        <Skeleton animation="wave" height={30} width={40} style={{ borderRadius: 12 }} />
        <Skeleton animation="wave" height={30} width={160} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
        <Skeleton animation="wave" variant="rect" height={120} width={"100%"} style={{ borderRadius: 12 }} />
        <Skeleton animation="wave" variant="rect" height={120} width={"100%"} style={{ borderRadius: 12 }} />
        <Skeleton animation="wave" variant="rect" height={120} width={"100%"} style={{ borderRadius: 12 }} />
        <Skeleton animation="wave" variant="rect" height={120} width={"100%"} style={{ borderRadius: 12 }} />
      </div>
      <Skeleton
        animation="wave"
        variant="rect"
        height={60}
        width={"100%"}
        style={{ borderRadius: 12, marginTop: 20 }}
      />
      <Skeleton
        animation="wave"
        variant="rect"
        height={60}
        width={"100%"}
        style={{ borderRadius: 12, marginTop: 20 }}
      />
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <Skeleton animation="wave" height={30} width={"60%"} style={{ marginBottom: 20 }} />
        <Skeleton animation="wave" height={30} width={200} />
        <Skeleton animation="wave" height={30} width={160} />
      </div>
      <Skeleton
        animation="wave"
        variant="rect"
        height={60}
        width={"100%"}
        style={{ borderRadius: 12, marginTop: 20 }}
      />
      <Skeleton
        animation="wave"
        variant="rect"
        height={60}
        width={"100%"}
        style={{ borderRadius: 12, marginTop: 20, marginBottom: 20 }}
      />
    </>
  )
}

export default WhatsappModalSkeleton
